import * as React from 'react';
import { BaseContainer, CommonHeaderProps } from '../common';
import { ContainerContext } from '../../containers';
import { toLink } from '../../utils';
import { Gavel, GroupOutlined as GroupIcon } from '@mui/icons-material';
import { PropsWithChildren } from 'react';

interface Props extends ContainerContext.Props, CommonHeaderProps, PropsWithChildren {
    readonly showSubTabs?: boolean;
}

export class BaseCheaterContainer extends React.Component<Props> {
    private readonly tabs = [
        {
            title: 'List',
            path: '/cheaters/all',
        },
        {
            title: 'Filter',
            path: '/cheaters/filter',
        },
    ];

    render() {
        const { loading, title, headline, children, buttons, showSubTabs } = this.props;
        const subTabsTitles = this.tabs.map(tab => tab.title);
        const selectedTab = this.subTabsSelected();

        const headlines = [
            {
                text: 'Cheaters',
                to: this.tabs[0].path,
            },
            {
                text: this.tabs[selectedTab].title,
                to: this.tabs[selectedTab].path,
            }
        ];

        if(showSubTabs) {
            return (
                <BaseContainer
                    loading= {loading}
                    styled={this.props.styled}
                    title = {'Cheaters'}
                    TitleIcon={Gavel}
                    headline = {headline}
                    headlines = {headlines}
                    subTabs={{
                        titles: subTabsTitles,
                        selected: this.subTabsSelected(),
                        onChange: this.changeSubTabs,
                    }}
                    buttons={buttons}
                >
                    {children}
                </BaseContainer>
            );
        }

        return (
            <BaseContainer
                loading= {loading}
                styled={this.props.styled}
                title = {title}
                TitleIcon={GroupIcon}
                headline = {headline}
                headlines = {headlines}
                buttons={buttons}
            >
                {children}
            </BaseContainer>
        );
    }

    private readonly subTabsSelected = () => {
        for (let i = 0; i < this.tabs.length; i++) {
            if (location.pathname.includes(this.tabs[i].path)) {
                return i;
            }
        }
        return 0;
    };

    private readonly changeSubTabs = (tab: number) => {
        let to = this.getPath('all');
        toLink(this.props, this.tabs[tab]?.path ?? to);
    };

    private readonly getPath = (component: string) => {
        return `/cheaters/${component}`;
    };
}
